import React, { useEffect } from 'react';

import { hasRoles, EDIT_PARTICIPANT_REVIEW_ROLES } from '../../../../util/RoleUtil';

import { viewQuery } from '../../../../services/QueryService';

import { SaveButton } from '../../../common/button/save-button/SaveButton';
import { Table } from '../../../common/table/Table';

import '../create/ParticipantReviewCreate.css';

export const ParticipantQueryTable = ({
  queries,
  setQuery,
  handleSaveClick,
  setShowQueriesTab,
  setShowQueriesTable,
  setIsNew,
  navigateTo,
  context,
  setActiveTab,
  setSpinnerText,
  showToaster,
}) => {
  useEffect(() => {
    setActiveTab('participantQueryTable');
  }, [setActiveTab]);

  const handleRowClick = (selectedQuery) => {
    setIsNew(false);
    retrieveQuery(selectedQuery.queryExternalReference);
  };

  const retrieveQuery = async (queryExtRef) => {
    setSpinnerText('Retrieving Query');
    const [data, error] = await viewQuery(context.username, queryExtRef);
    if (data) {
      if (data.responseStatus === 'Success') {
        setQuery(data.viewQueryVO);
        await handleSaveClick('participantReviewCreateQuery');
        await setShowQueriesTab(true);
        await setShowQueriesTable(false);
        showToaster({
          responseStatus: 'Success',
          responseMessage: 'Query successfully retrieved.',
        });
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  const handleAddButtonClick = () => {
    setQuery({});
    setIsNew(true);

    handleSaveClick('participantReviewCreateQuery');
    setShowQueriesTab(true);
    setShowQueriesTable(false);
  };

  return (
    <div className="participant-query-table">
      {queries && (
        <Table
          tableData={queries}
          filterEnabled={true}
          tableTitle={'Queries'}
          buttonText={hasRoles(context, EDIT_PARTICIPANT_REVIEW_ROLES) ? 'Create New' : undefined}
          buttonOneWidth={'135px'}
          onButtonClick={handleAddButtonClick}
          onRowClick={handleRowClick}
          searchEnabled={true}
          maxRowCount={6}
          hiddenColumns={['queryExternalReference']}
          horizontalScroll
        />
      )}
      <div className={'review-button-container'}>
        <SaveButton
          color={'#74a47f'}
          title={'Close'}
          onClick={() => {
            navigateTo('participantReviewsTable');
          }}
        />
      </div>
    </div>
  );
};
